<template>
  <div>
    <div class="reply-button-wrapper">
      <Button
        type="success"
        style="margin-right: 5px;"
        @click="onSubmit"
      >
        {{ submitLabel }}
      </Button>
      <Button @click="onCancel">
        Cancel
      </Button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      submitLabel: this.isEdit ? 'Update' : 'Reply'
    }
  },

  methods: {
    /**
     * Emit signal to update data to vuex and submit reply to database
     */
    async onSubmit () {
      this.$emit('onSubmit')
    },

    /**
     * Hides the content editor or make it non-editable.
     */
    onCancel () {
      this.$emit('onCancel')
    }
  }
}
</script>

<style scoped>
.reply-button-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 5px;
}
</style>
